const messages = {
  trade: {
    text1: "Product name",
    text2: "Favourites",
    text3: "Products",
    text4: "Ask",
    text5: "Spread",
    text6: "Last price",
    text7: "Bid",
    text8: "%Change",
    text9: "Removed from favourites",
    text10: "Added to favourites",
    text11: "High",
    text12: "Low",
    text13: "Quotes",
    text14: "Rules",
    text15: "Analysis",
    text16: "Trading period(UTC+8)",
    text17: "Day",
    text18: "Quote",
    text19: "Live Trading",
    text20: "Market Analysis",
    text21: "Short",
    text22: "Long",
    text23: "Interpretation of indicators",
    text24: "m",
    text25: "h",
    text26: "d",
    text27: "w",
    text28: "MN",
    text29: "Summary",
    text30: "Buy",
    text31: "StrongBuy",
    text32: "Sell",
    text33: "StrongSell",
    text34: "Neutral",
    text35: "Oscillator",
    text36: "Strong",
    text37: "Indicators",
    text38: "Numerical value",
    text39: "Signal",
    text40: "Moving average",
    text41: "Name",
    text42: "more",
    text43: "Pivot point",
    text44: "Classic",
    text45: "Fibonacci",
    text46: "Live account",
    text46_1: "Demo account",
    text47: "Positions",
    text48: "Pending order",
    text49: "Close all positions",
    text50: "Product",
    text51: "Direction",
    text52: "Lot",
    text53: "Open price",
    text54: "Last price",
    text55: "Floating PnL",
    text56: "Margin",
    text57: "Swap",
    text58: "Take profit price",
    text59: "Stop loss price",
    text60: "Opening time",
    text61: "Transaction number",
    text62: "Operate",
    text63: "Close position",
    text64: "Close and reverse",
    text65: "Take profit and Stop loss",
    text66: "no data",
    text67: "Login",
    text68: "Closing product",
    text69: "Holding lots",
    text70: "Lots to close",
    text71: "Floating PnL",
    text72: "Cancel",
    text73: "Confirm",
    text74:
      " Promotion shares have been confirmed and can be unlocked after verification. ",
    text75: "Order details",
    text76: "Closing PnL",
    text77: "Closing price",
    text78: "Rebate",
    text79: "Swap",
    text80: "Minimum ",
    text81: " lots can be closed",
    text82: "Maximum ",
    text83: "Are you sure to close all positions?",
    text84: "OK",
    text85: "Confirm to close current position and open a new reverse order?",
    text86: "Success",
    text87: "Pending order price",
    text88: "Estimated margin",
    text89: "Order time",
    text90: "End date",
    text91: "Modify order",
    text92: "Cancel order",
    text93: "Modify order",
    text94:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/accountInformation/icon_buy_red%402x.png",
    text94_green:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_green_up_buy_en.png",
    text94_blue:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_blue_up_buy_en.png",
    text95:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/accountInformation/icon_sell_green%402x.png",
    text95_green:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_green_up_sell_en.png",
    text95_blue:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_green_up_sell_en.png",
    text96: "Price",
    text97: " or ",
    text98: "Estimated profit",
    text99: "Estimated loss",
    text100: "Order expiry time",
    text101: "Please enter the pending order price",
    text102: "Stop loss setting",
    text103: "Stop profit setting",
    text104: "Not set",
    text105: "Invalid pending order price",
    text106:
      "The pending order deadline should be greater than the current latest time",
    text107: "Confirm cancellation？",
    text108: "Live account",
    text109: "Balance",
    text110: "Equity",
    text111: "Floating PnL",
    text112: "Free margin",
    text113: "Margin",
    text114: "Credit bonus",
    text115: "Margin level",
    text116: "Type",
    text117: "Market trading",
    text118: "Pending order",
    text119: "Lots",
    text120: "Pending order price",
    text121: "closed",
    text122: "Please enter trading password",
    text122_1: "Please confirm the operation",
    text123: "Trading product",
    text124: "Forgotten password",
    text125: "Insufficient margin",
    text126: "The trading password has been locked",
    text127: "please reset trading password",
    text128: "Retrieve trading password",
    text129: `The lot size can't be less than`,
    text130: `The lot size can't be higher than`,
    text131: `Please enter the pending order price`,
    text132: `You need to make a deposit before you can use the bonus`,
    text133: `Take profit and Stop loss`,
    text134: `Closing time`,
    text135: `1m`,
    text136: `5m`,
    text137: `15m`,
    text138: `30m`,
    text139: `1h`,
    text140: `4h`,
    text141: `1d`,
    text142: `1w`,
    text143: `1m`,
    text144: `Order confirmation`,
    text145: `Buy`,
    text146: `Sell`,
    text147: `Trade`,
    text148: `The demo account has expired`,
    text149: "Partial close",
    text150: "Instant trading opened",
    text151: "Click to expand",
    text152:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_zk_right_en.png",
    text153:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_sq_right_en.png",
    text154:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_zk_left_en.png",
    text155:
      "https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_sq_left_en.png",
    text156: "Demo Trading",
    text157: `You are about to activate Instant Trading mode. By clicking "I Accept
          these Terms and Conditions" below, you acknowledge that you have read
          and understood the following terms and conditions, and you agree to be
          bound hereby. Your current version of the terminal enables you to
          choose between the following modes for order submission. You agree
          that you will be bound by the procedures and conditions specified
          herein with respect to each such mode.`,
    text158: `1. The Default mode for order submission is a two-step process: you
          first open a new order window, then you select an appropriate order
          type, its parameters, and confirm your order submission by clicking
          either Buy, Sell, Place, Modify or Close buttons depending on the
          particular order type selected and your trading intentions. Your order
          will not be submitted until you have completed both of the
          aforementioned steps.`,
    text159: `2. The Instant Trading mode for order submission is a one-step
          process. Your order will be submitted when you:`,
    text160: `on a chart click either bid (SELL) or ask
          (BUY) rate button:`,
    text161: `delete orders in the Trade tab of the web
          window`,
    text162: `THERE WILL BE NO SUBSEQUENT CONFIRMATION PROMPT FOR YOU TO CLICK. YOU
          WILL NOT BE ABLE TO WITHDRAW OR CHANGE YOUR ORDER ONCE YOU CLICK.
          UNDER NORMAL MARKET CONDITIONS AND SYSTEM PERFORMANCE, A MARKET ORDER
          WILL BE PROMPTLY FILLED AFTER SUBMISSION AND YOU WILL HAVE ENTERED
          INTO A BINDING TRANSACTION.`,
    text163: `You can activate or deactivate Instant Trading mode on the Trade tab
          of Options window of the web browser.`,
    text164: `By selecting the Instant Trading mode, you understand that your orders
          will be submitted by clicking the bid or ask rate button or in any
          other way described above, without any further order confirmation. You
          agree to accept all risks associated with the use of the order
          submission mode you have chosen, including, without limitation, the
          risk of errors, omissions or mistakes made in submitting any order.`,
    text165: `You agree to fully indemnify and hold harmless DayDayTrade from any and
          all losses, costs and expenses that it may incur as a result of any
          such errors, omissions or mistakes by you, your trading manager or any
          other person trading on your behalf.`,
    text166: `I accept the above contract terms`,
    text167: 'Disclaimer',
    text168: 'Colour preferences',
    text169: 'Red rise ',
    text170: 'Green fall',
    text171: 'Green rise ',
    text172: 'Red fall',
    text173: 'Blue rise ',
    text174: 'Instant trading',
    text175: 'Open',
    text176: 'Close',

  },
  signUp: {
    text1: "Register now to start",
    text2: "your investment journey",
    text3:
      "Support Subscription, Copy Transactions, and Share Profits with Top Traders.",
    text4: "Fund safety - Rapid deposit and withdrawal.",
    text5: "User friendly - fulfilling the needs of the different investors.",
    text6:
      "Excellent Resource - free trading analysis and 1 on 1 trading guideline.",
    text7: "Mobile Verification Login",
    text8: "New users can register and log in directly",
    text9: "Phone",
    text10: "Email",
    text11: "By clicking the button,you understand and agree to the",
    text12: "《CLIENT AGREEMENT》",
    text13: "Enter phone number",
    text14: "Select Region",
    text15: "Enter verification code",
    text16: "Get Code",
    text17: "Resend",
    text18: "Sending",
    text19: "Send completed",
    text20: "please enter phone number",
    text21: "Successful landing",
    text22: "Register/Login",
    text22_1: "Login",
    text23: "Use password to login",
    text24: "Mobile Verification login/register",
    text25: "Forgotten password",
    text26: "Email address",
    text27: "Enter password",
    text28: "Phone",
    text29: "Email",
    text30: "Set login password",
    text31: "Enter a 8-15 digits and letters combination",
    text32: "Please confirm password",
    text33: "Passwords do not match",
    text34: "Skip",
    text35: "Confirm",
    text36: "Set successfully",
    text37: "Please enter a 8-15 digits and letters combination",
    text38: "Login/Register",
    text39: "Password does not match, please re-enter",
    text40: "Password reset successful",
    text41: "Email verification code",
    text42: "please enter email",
    text43: "Email format error",
    text44: "Verification code error",
    text45: "No permission, please contact customer service",
    text46: "Verification Login",
  },
  components: {
    text1: "Change trading password",
    text2: "Enter a 6-digit password",
    text3: "Please enter a 6-digit password",
    text4: "Transaction password cannot be a repeat of six digits",
    text5: "Transaction password 6 digits",
    text6: "Transaction password cannot be consecutive six digits",
    text7: "Change successfully",
    text8: "Set trading password",
    text9: "Transaction password cannot be repeated or consecutive 6 digits",
    text10: "Please confirm passwords",
    text11: "Unbind",
    text12: "Select a bank card",
    text13: "Bind email",
    text14: "Enter phone verification code",
    text15: "Next",
    text16: "Enter email address",
    text17: "Enter email verification code",
    text18: "Email binding successfully",
    text19: "PhoneNumber binding successfully",

  },
  myAccount: {
    text1: "My account",
    text2: "Account assets",
    text3: "Historical orders",
    text4: "Deposit",
    text5: "Withdrawal",
    text6: "Funds Details",
    text7: "Fund history",
    text8: "Fund transfer",
    text9: "Basic infomation",
    text10: "Avatar",
    text11: "Change",
    text12: "Nickname",
    text13: "DayDayTrade account",
    text14: "Mobile phone number",
    text15: "Verification",
    text16: "Proof of address",
    text17: "Unsubmitted",
    text18: "Reviewing",
    text19: "Address proof error",
    text20: "MT5 live account",
    text21: "Personal information",
    text22: "Submit",
    text23: "Edit",
    text24: "Email",
    text25: "Unbind",
    text26: "Bind",
    text27: "Security center",
    text28: "Login password",
    text29: "Set",
    text30: "MT5 live account password",
    text31: "Reset",
    text32: "Trading password",
    text33: "Bank card",
    text34: "Add",
    text35: "Withdrawal address",
    text36: "Delete",
    text37: "Unverified",
    text38: "Verified",
    text39: "Identity Verification failed",
    text40: "Upload",
    text41: "Invalid Signature",
    text42: "Failure of address authentication",
    text43: "No ID uploaded",
    text44: "Signature not yet submitted",
    text45: "waiting ID selfie photo to be uploaded",
    text46: "Selfie photo invalid",
    text47: "Confirm to unbind email",
    text47_1: "Unbind phone number?",
    text48: "Email unbind successfully",
    text48_1: "Phone number unbinding completed",
    text49: "The MT5 Live password can only be reset once a day",
    text50: "Unbind your ",
    text51: " card ending in ",
    text52: "Unbind successfully",
    text53: "Delete the withdrawal address?",
    text54: "Address deleted successfully?",
    text55:
      "According to compliance requirements, you have to submit the address proof documents.",
    text56: "Resubmit",
    text57:
      "Your proof of address did not pass the verification, please resubmit",
    text58: "Attach Document",
    text59:
      "* The answers to the following questions will be used to monitor risks and optimise risk reminders,please answer accurately",
    text60: "Family member in household",
    text61: " person",
    text62: " persons",
    text63: " persons and above",
    text64: "Marital status",
    text65: "Married",
    text66: "Single",
    text67: "Divorced",
    text68: "Widowed",
    text69: "Career status",
    text70: "Employed",
    text71: "Unemployed",
    text72: "Student",
    text73: "Retired",
    text74: "Select industry",
    text75: "Finance/Banking/Insurance",
    text76: "Government/Institution",
    text77: "Advertising PR/Media/Art and Culture",
    text78: "Sales/Trade",
    text79: "Computer/Internet/Communication/Electronic Technology",
    text80: "Manufacturing/logistics transportation",
    text81: "Pharmaceutical/Chemical",
    text82: "Construction/Real Estate",
    text83: "Education/Legal",
    text84: "Catering/Entertainment/Beauty",
    text85: "Other",
    text86: "Total net asset value",
    text87: "Investment objective",
    text88: "Investment experience",
    text89: "Less than ",
    text90: "Asset appreciation",
    text91: "Speculation",
    text92: "Arbitrage",
    text93: "Hedge",
    text94: " year",
    text95: " years",
    text96: "More than",
    text96_1: '',
    text97: "success",
    text98: "Modify avatar",
    text99: "Avatar",
    text100: "Update",
    text101: "Modify completed",
    text102: "The length of the nickname cannot exceed 15 characters",
    text103: "Please input",
    text104: " login password",
    text105: "Change login password",
    text106: "Enter original password",
    text107: "Login password reset complete",
    text108: "Reset MT5 live password",
    text109: "* The new MT5 password will be sent to your mobile phone",
    text110: "Add available bank card",
    text111: "Beneficiary name",
    text112: "Currency",
    text113: "Bank name",
    text114: "Bank account number",
    text115: "Swift code",
    text116: "Bank address",
    text117: "Please enter",
    text118: "Save",
    text119: "Select available bank",
    text120: "Bank card added successfully",
    text121: "Choose bank name",
    text122: "Add withdrawal address",
    text123: "Remarks",
    text124: "No more than 10 characters",
    text125: "Address added successfully",
    text126: "Please select",
    text127: "Modify nickname",
    text128: "Add bank card",
    text129: "Bank code",
    text130: "Choose or enter bank name",
    text131: "Select withdrawal address",
    text132: "View",
    text133: "More than ",
    text134: "Less than 100,000 USD",
    text135: "100,000 - 200,000 USD",
    text136: "200,000 - 300,000 USD",
    text137: "300,000 - 500,000 USD",
    text138: "500,000 - 1,000,000 USD",
    text139: "1,000,000 - 5,000,000 USD",
    text140: "5,000,000 - 10,000,000 USD",
    text141: "More than 10,000,000 USD",
    text142: "MT4 live account",
    text143: "MT4 live account password",
    text144: "The MT4 Live password can only be reset once a day",
    text145: "Reset MT4 live password",
    text146: "* The new MT4 password will be sent to your mobile phone",
    text147: "Please enter bank name",
    text148: "Details",
    text149: "Verification",
    text150: "Personal information",
    text151: "My account",
    text152: "Verification status",
    text153: "Verification steps",
    text154: "Web account",
    text155: "MT4 account",
    text156: "Add account",
    text157: "Confirm to add new account?",
    text158: "Confirm",
    text159: "Cancel",
    text160: "OK",
    text161: "Failed to add a new account. The number of accounts cannot exceed 5.",
    text162: "Failed to add new account",
    text163: "Failed to add new MT4 account",
    text164: "OK",
    text165: "Verification steps",
    text166: "Basic information",
    text167: "Identity Authentication",
    text168: "Email verification",
    text169: "Phone verification",
    text170: "",
    text171: "step completed",
    text172: "Leverage adjustment",
    text173: "MT4 Leverage adjustment",
    text174: "Select",
    text175: "Leverage Ratio",
    text176: "All",
    text177: "Adjust MT4 account to",
    text178: "x leverage?",
    text179: "Download",
    text180: "MetaTrader 4 for Desktop",
    text181: "Click to download",
    text182: "MetaTrader 4 App",
    text183: "The leverage adjustment application of MT4 account has been submitted successfully, and the review result will be sent via SMS/email",
  },
  AccountAssets: {
    text1: "Live account",
    text2: "Account assets",
    text3: "Equity",
    text4: "Balance",
    text5: "Floating PNL",
    text6: "Credit bonus",
    text7: "Free Margin",
    text8: "Margin",
    text9: "Margin level",
    text10: "Total PNL",
    text11: "Total rebate",
    text12: "Total deposit",
    text13: "Total withdrawal",
    text14: "Trading products",
    text15: "Opening time",
    text16: "All",
    text17: "Start date",
    text18: "End date",
    text19: "Search",
    text20: "Statistics",
    text21: "Total swap",
    text22: "Total lots",
    text23: "Total orders",
    text24: "Closed",
    text25: "Cancelled",
    text26: "Country",
    text27: "Last name",
    text28: "First name",
    text29: "Date of birth(MM/DD/Year)",
    text30: "Full address",
    text31: "ID number",
    text32:
      "Verification must be completed in order to trade and enjoy further services",
    text33: "Confirm to quit verification?",
    text34: "Continue verification",
    text35: "Verification",
    text36: "Informations",
    text37: "Upload documents",
    text38: "Confirm agreement",
    text39: "Supporting Documents:",
    text40: "Photo ID",
    text41:
      "Please provide a colour photo copy of the main page of your current valid passport, or both sides of your photo ID or driving licence.",
    text42: "Required",
    text43: "Address Proof",
    text44:
      "Please provide a scanned copy or photo of utility bills, bank statement or other kind of documents with address issued within last 6 months,suggest to provide bank statement in a pdf format.",
    text45: "Optional",
    text46: "File example",
    text47: "Correct",
    text48: "example",
    text49: "Information",
    text50: "ambiguity",
    text51: "Missing",
    text52: "corners",
    text53:
      "Please confirm that you have read and agree to the following agreemen：",
    text54: "《Client Agreement》",
    text55: "《Form W8-BEN》",
    text56: "《ANNEX I CONFLICT OF INTEREST》",
    text57: "《ANNEX II Risk Disclosure》",
    text58: "《ANNEX III Best Execution Policy》",
    text59: "Please confirm the following statement：",
    text60: "I am the ultimate beneficiary of this account",
    text61: "I am not a U.S. citizen or a citizen for tax purposes",
    text62: "I am not an DayDayTrade agent or related to any of their staff",
    text63: `All information provided by me is true and accurate, and I agree to notify DayDayTrade by phone or email if any information changes. If necessary, I authorize DayDayTrade to confirm the accuracy of the information, and sign it to indicate that I've read and understand the content of the risk warning policy.`,
    text64: `Account opening under review`,
    text65: `Your information has been submitted, please allow 1-2 working days for the reviewal process, once successful you will be notified, do not hesitate to contact us if you have any questions.`,
    text66: `Time`,
    text67: `Total bonus`,
    text68: `Total transfer`,
    text69: `Amount`,
    text70: `Transfer type`,
    text71: `Amount to transfer`,
    text72: `Transferable amount`,
    text73: `Verification`,
    text74: `* We have received your application. In order to fulfil DayDayTrade regulation compliance system and to prevent others from maliciously using your identity, you need to upload a selfie holding your ID document.`,
    text75: `Please upload selfie holding your ID document`,
    text76: `Please upload selfie displaying the front of your ID document.`,
    text77: `The profile picture and text must be clear,  without reflections.`,
    text78: `The entire face and the four corners and borders of the ID card must be included.`,
    text79: `Selfie example`,
    text80: `Cancel`,
    text81: `Submit`,
    text82: `I have read the full agreement. I understand the risks and would like to continue to open an account with DayDayTrade`,
    text83: `Clear signature`,
    text84: `Please sign here`,
    text85: `High-risk aged category investors agreement:`,
    text86: `* According to the DayDayTrade compliance system, you have to submit the proof of address documents.`,
    text87: `* Your proof of address did not pass the verification, please resubmit.`,
    text88: `Address Proof`,
    text89: `Proof of address under review`,
    text90: `Web live account`,
    text91: `Web demo account`,
    text92: `MT4 live account`,
    text93: `MT4 demo account`,
    text94: `Transfer out`,
    text95: `Transfer in`,
    text96: `You can add a new MT4 account only after passing the real-name authentication`,
    text97: `Order No.`,
    text98: `Order time`,
    text99: `Type`,
    text100: `Lot`,
    text101: `Trading product`,
    text102: `Open price`,
    text103: `Stop loss price`,
    text104: `Take profit price`,
    text105: `Closing time`,
    text106: `Closing price`,
    text107: `Handling fee`,
    text108: `Holding Fee`,
    text109: `Closing PnL`,
    text110: `MT4 account`,
    text111: `Web account`,
    text112: `Total fee`,
  },
  fundHistory: {
    text1: "Deposit",
    text2: "Withdrawal",
    text3: "Bonus",
    text4: "Rebate",
    text5: "Transfer",
    text6: "Deposit type",
    text7: "Order status",
    text8: "Time",
    text9: "Status",
    text10: "Deposit amount",
    text11: "Time",
    text12: "Operate",
    text13: "Details",
    text14: "Status",
    text15: "Currency",
    text16: "Deposit amount",
    text17: "Payment amount",
    text18: "Submission time",
    text19: "Arrival time",
    text20: "Click on the wallet address or TxHash to view blockchain details",
    text21: "Address",
    text22:
      "The order has been confirmed for payment, waiting for the funds to arrive",
    text23: "The order will expire after",
    text24:
      "(please send money as soon as possible and confirm the payment complete)",
    text25: "Purchase quantity",
    text26: "Payment amount",
    text27: "Payment method",
    text28: "Account number",
    text29: "Payee",
    text30: "Cancel order",
    text31: "Payment confirmed",
    text32: "Confirm to cancel the order?",
    text33: "Order canceled successfully",
    text34: "Order confirmation has completed payment?",
    text35: "Order confirmation successfully",
    text36: "Loading",
    text37: "Withdrawal type",
    text38: "Withdrawal amount",
    text39: "Estimated credited",
    text40: "Handling fee",
    text41: "Revoke",
    text42: "Receipt amount",
    text43: "Handling fee",
    text44: "Recipient bank",
    text45: "Confirm whether to cancel the withdrawal order?",
    text46: "Revocation successful",
    text47: "Bonus type",
    text48: "Type",
    text49: "Commission type",
    text50: "Total Commission",
    text51: "Trading lots",
    text52: "Transaction time",
    text53: "Transfer amount",
    text54: "Transfer to",
    text55: "Transaction time",
    text56: "Minimum transfer amount ",
    text57: "Exceeded transferable amount",
    text58: "Submitted successfully",
  },
  deposit: {
    text1: "Choose the currency",
    text2:
      "*Please select the currency you want to payment, we will provide the appropriate deposit channel according to the currency you choose.",
    text3: "Process transfer",
    text4: "Upload documentation",
    text5: "Completed",
    text6: "Bank information",
    text7: "Reveal",
    text8: "Payee name",
    text9: "Payee local area",
    text10: "Please fill your remittance information",
    text11: "Remittance bank",
    text12: "Remittance amount",
    text13: "Remittance documentation",
    text14: "*Uploaded image size must not be exceed 4MB",
    text15: "Bank information",
    text16: "Payee name",
    text17: "Payee local area",
    text18: "Payee address",
    text19: "Payee bank",
    text20: "Payee account",
    text21: "Payee bank address",
    text22: "swift code",
    text23: "Copy all information",
    text24: "Copy completed",
    text25: `The deposit amount can't be less than `,
    text26: `Submitted successfully, after the bank confirms details, the amount will be credited usually upto 1 working day, please wait patiently. `,
    text27: `Choose currency`,
    text28: `Blockchain type`,
    text29: `Exchange rate`,
    text30: `Deposit amount`,
    text31: `Estimated payment amount`,
    text32: `Please enter amount`,
    text33: `Your personal `,
    text34: ` deposit address`,
    text35: "Single limit ",
    text36: `Max `,
    text37: `Min `,
    text38: `Channel`,
    text39: `Deposit amount`,
    text40: `Other`,
    text41: `Fee`,
    text42: `Payment amount`,
    text43: `Exchange rate`,
    text44: `Country`,
    text45: `Bank`,
    text46: `Confirm`,
    text47: `Please note:`,
    text48: `Exchange rate`,
    text49: `Purchase quantity`,
    text50: `Verification`,
    text51: `*The initial payment amount is an estimation, please pay according to the real-time generated order amount.`,
    text52: `Incomplete Orders`,
    text53: `The order will expire after `,
    text54: `(please send money as soon as possible and confirm the payment complete)`,
    text55: `*The order has been confirmed for payment, waiting for the funds to arrive`,
    text56: `Status`,
    text57: `Payment method`,
    text58: `Deposit amount`,
    text59: `Account number`,
    text60: `Copy`,
    text61: `Payee`,
    text62: `Time`,
    text63: `Cancel order`,
    text64: `Payment confirmed`,
    text65: `You have an unpaid order, unable to initiate a new order`,
    text66: `Proceed to payment`,
    text67: `Cancel`,
    text68: `Confirm to cancel the order?`,
    text69: `Order canceled successfully`,
    text70: `Order confirmation has completed payment?`,
    text71: `m`,
    text72: `s`,
    text73: `Deposit page error`,
  },
  withdraw: {
    text1: `Channel`,
    text2: `Exchange rate`,
    text3: `Available amount`,
    text4: `Withdrawal amount`,
    text5: `Estimated receipt amount`,
    text6: `All`,
    text7: `Verification`,
    text8: `Recipient account`,
    text9: `Add available bank card`,
    text10: `Use another bound card`,
    text11: `*The initial payment amount is an estimation, please pay according to the real-time generated order amount.`,
    text12: `Confirm`,
    text13: `Latest Order`,
    text14: `Status`,
    text15: `Recipient  bank`,
    text16: `Withdrawal amount`,
    text17: `Account number`,
    text18: `Estimated credited`,
    text19: `Payee`,
    text20: `Time`,
    text21: `Revoke`,
    text22: `Loading`,
    text23: `Single limit `,
    text24: `Max `,
    text25: `Min `,
    text26: `Risk warning`,
    text27: `Withdraw`,
    text28: `Cancel`,
    text29: `Submitted successfully`,
    text30: `Copy completed`,
    text31: `Confirm whether to cancel the withdrawal order`,
    text32: `OK`,
    text33: `Withdrawable amount = Equity - Credit bonus - Cash bonus - Pending orders amount`,
    text34: `For clients with open positions：`,
    text35: `Withdrawable Amount = Equity - Credit Bonus - Cash bonus - Pending Orders amount - Used Margin / Leverage X 2%`,
    text36: `(2% is a valuation of the maximum loss of your position, to ensure that the withdrawal does not affect your current position)`,
    text37: `Description of available amount`,
    text38: `Choose the currency`,
    text39: `*Please select the currency you want to receive, we will provide the appropriate withdrawal channel according to the currency you choose.`,
    text40: `Receipt currency`,
    text41: `Expected receipt amount`,
    text42: `Exchange rate`,
    text43: `Bank card information`,
    text44: `Available banks`,
    text45: `Beneficiary name`,
    text46: `Bank name`,
    text47: `Bank address`,
    text48: `Bank account number`,
    text49: `Swift code`,
    text50: `Please fill in additional information`,
    text51: `To withdraw funds using this channel,please use the following banks to receive payments.`,
    text52: `This bank is not supported`,
    text53: `Choose a bank card`,
    text54: `Add bank card`,
    text55: `Bank code`,
    text56: `Choose currency`,
    text57: `Blockchain type`,
    text58: `Available amount`,
    text59: `Handling fee`,
    text60: `Withdrawal address`,
    text61: `Select or enter address`,
    text62: `Select`,
    text63: `Expected deduction`,
    text64: `*The initial payment amount is an estimation,amount received may differ slightly due to market conditions and exchange rates`,
    text65: `Description of available amount`,
    text66: `*For users without positions：`,
    text67: `Available amount=Equity-Credit bonus-Cash bonus-Pending orders amount`,
    text68: `*For users with open positions:`,
    text69: `Available amount=Equity-Credit bonus-Cash bonus-Pending orders amount-Used margin/Leverage*1%`,
    text70: `(1% is a valuation of the maximum loss of your position, to ensure that the withdrawal does not affect your current position )`,
    text71: "Safety verification",
    text72:
      "*To ensure the safety of your blockchain funds,you need to verify your account",
    text73: "Exceeded available amount",
    text74: "Account",

  },
  proxy: {
    text1: "IB System",
    text2: "Home",
    text3: "Main",
    text4: "Data Filter",
    text5: "Client Type",
    text6: "My Own Clients",
    text7: "Sub-IB's Client",
    text8: "Period",
    text9: "This Year",
    text10: "This month",
    text11: "This week",
    text12: "Today",
    text13: "Search",
    text14: "Data Overview",
    text15: "Number of Agents (person)",
    text16: "No. of Registrations (person)",
    text17: "No. of Accounts Opened (person)",
    text18: "Withdrawable Rebates",
    text19: "Total Trading Volume (Lots)",
    text20: "Total Rebate (USD)",
    text21: "Net Deposit (USD)",
    text22: "Total Deposit (USD)",
    text23: "Total Withdrawals (USD)",
    text24: "Personal Info",
    text25: "Agent Info",
    text26: "Name",
    text27: "Contacts",
    text28: "Contact Number",
    text29: "H5 Registration Link",
    text30: "Copy",
    text31: "Registration QR code",
    text32: "Save QR Code",
    text33: "Full Name",
    text34: "Email",
    text35: "ID Number",
    text36: "Address",
    text37: "MT5 Real Account",
    text38: "MT5 Demo account",
    text39: "Web Account",
    text40: "Rebate Rule Settings",
    text41: "Rebate Rule Name",
    text42: "Add New Rebate Rules",
    text43: "Set as template",
    text44: "Yes",
    text45: "No",
    text46: "Status",
    text47: "Normal",
    text48: "Disabled",
    text49: "Products Rebate Configuration",
    text50: "Upload Rebate Rule Template",
    text51: "Default Settings",
    text52: "No.",
    text53: "Rebate Owned",
    text54: "Rebate Remained",
    text55: "Sub-IB Rebate",
    text56: "Sub-IB Rebate Ratio",
    text57: "Rebate Rule Name",
    text58: "Set as Template",
    text59: "Last Modified Time",
    text60: "No Data",
    text61: "IB settings",
    text62: "IB name",
    text63: "Create Time",
    text64: "Add New IB",
    text65: "IB ID",
    text66: "No. of Users",
    text67: "No. of Accounts Opened",
    text68: "Edit",
    text69: "Basic Information",
    text70: "Nick Name",
    text71: "Site Name",
    text72: "For Example",
    text73: "URL",
    text74: "IB WhatsApp",
    text75: "IB Telegram",
    text76: "Remark",
    text77: "Customer Settings",
    text78: "Account Status",
    text79: "Unverified",
    text80: "Verifying",
    text81: "Verified",
    text82: "Verification Failed",
    text83: "Registration Time",
    text84: "User ID",
    text85: "Data",
    text86: "Transaction History",
    text87: "Products",
    text88: "Customer",
    text89: "Phone Number",
    text90: "MT5 Account",
    text91: "Reset",
    text92: "Expand",
    text93: "Hide",
    text94: "Direction",
    text95: "All",
    text96: "Buy",
    text97: "Sell",
    text98: "Trading Status",
    text99: "Closed",
    text100: "Open position",
    text101: "Closed By",
    text102: "User",
    text103: "System",
    text104: "Take Profit",
    text105: "Stop Loss",
    text106: "Delivery Time",
    text107: "Forced Liquidation",
    text108: "Follow to Close",
    text109: "Follow to Open",
    text110: "Manual",
    text111: "Web Account",
    text112: "Trading Account",
    text113: "Open Date",
    text114: "Closing Date",
    text115: "P/L",
    text116: "Swap",
    text117: "Total Rebate",
    text118: "Lot Size",
    text119: "Export This Page",
    text120: "Export All",
    text121: "White Label",
    text122: "IB",
    text123: "MT5 Open Order No.",
    text124: "MT5 Close Order No.",
    text125: "Opening Price",
    text126: "Closing Price",
    text127: "Take Profit",
    text128: "Stop Loss",
    text129: "Trading Account",
    text130: "App Balance",
    text131: "App Equity",
    text132: "App Margin Ratio",
    text133: "MT5 Balance",
    text134: "MT5 Equity",
    text135: "MT5 Margin Ratio",
    text136: "Net Deposit",
    text137: "Net Commission",
    text138: "Rule Name",
    text139: "Action",
    text140: "View Positions",
    text141: "Position List",
    text142: "Total Floating P/L",
    text143: "Total Swap",
    text144: "Order No.",
    text145: "MT5 Order No.",
    text146: "Latest Price/ Current Price",
    text147: "Margin",
    text148: "Floating P/L",
    text149: "Swap",
    text150: "Settlement",
    text151: "Rebate Withdrawal",
    text152: "Account Type",
    text153: "Status",
    text154: "Reviewing",
    text155: "Payment Submitted",
    text156: "Rejected",
    text157: "Payment Confirmed",
    text158: "Application Time",
    text159: "Accumulated Rebate",
    text160: "Withdrawable Rebate",
    text161: "Rebate Withdrawn",
    text162: "Withdrawal",
    text163: "Apply ID",
    text164: "Amount",
    text165: "Receive account",
    text166: "Submit",
    text167: "Cancel",
    text168: "IB Withdrawal Application",
    text169: "Open Order Type",
    text170: "Follow trader",
    text171: "please select",
    text172: "Withdrawal amount exceed the limit",
    text173: "Withdrawal amount should be no less than 0! Please re-enter",
    text174: "processing",
    text175: "submit successfully",
    text176: "submit failed",
    text177: "Required fields can not be empty",
    text178: "Enable",
    text179: "Disabled",
    text180: "Bind live account",
    text181:
      "Note: You need to open live account first and then bind your live account",
    text182: "Next",
    text183: "IB System login credentials",
    text184: "Create login account",
    text185: "Check phone no.",
    text186: "Success",
    text187: "Fail",
    text188: "Comfirm to export all the data?",
    text189: "Duplicate symbol",
    text190: "Account setup",
    text191: "Manual trade",
    text192: "Copy trade",
    text193: "Web Terminal",
    text194: "MT5 Terminal",
    text195: "IB account",
    text196: "Rebate account",
    text197: "CopyTrading commission",
    text198: "Enable",
    text199: "Disabled",
    text200: "Data query conditions",
    text201: "Start Date",
    text202: "End Date",
    text203: "Total Rebate (USD)",
    text204: "Withdrawable Rebates (USD)",
    text205: "Net Deposit (USD)",
    text206: "Net value of live account at the beginning of the period (USD)",
    text207: "Net value of follow account at the beginning of the period (USD)",
    text208: "Net value of live account at the end of the period (USD)",
    text209: "Net value of follow account at the end of the period (USD)",
    text210: "Trend Analysis",
    text211: "Promotion Link",
    text212: "Rank",
    text213: "QR code",
    text214: "View",
    text215: "Copy Failure",
    text216: "MT4 Account",
    text217: "App Position",
    text218: "MT4 Position",
    text219: "Number of positions",
    text220: "Opening Price",
    text221: "App Open Order No.",
    text222: "App Close Order No.",
    text223: "Take Profit Price",
    text224: "Stop Loss Price",
    text225: "Low spreads",
    text226: "Normal spreads",
    text227: "High spreads",
    text228: "Trading symbols configuration",
    text229: "Trading rules group",
    text230: "Rule group name",
    text231: "Warning ratio",
    text232: "Liquidation ratio",
    text233: "Fixed Spreads",
    text234: "Trading symbols configuration",
    text235: "Upload Rule Group Template",
    text236: "Minimum Spread",
    text237: "Bid Spread",
    text238: "Ask Spread",
    text239: "Trading Spread",
    text240: "Rebate Owned",
    text241: "Rebate Ratio",
    text242: "Please select a rule group template",
    text243: "Save Complete",
    text244: "Save Failed",
    text245: "Failed to obtain the template",
    text246: "Failed to apply the template",
    text247: "Rule Group ID",
    text248: "Rule Group Status",
    text249: "Add Sub-IB rule group",
    text250: "View Sub-IB rule group",
    text251: "Failed to obtain rule group data",
    text252: "Failed to obtain the Sub-IB rule group",
    text253: "Type",
    text254: "Amount (Currency)",
    text255: "Amount",
    text256: "Log out",
    text257: "Attribution IB",
    text258: "Area code",
    text259: "Creation Date",
    text260: "View Account",
    text261: "Accumulated Rebate",
    text262: "Receiving account type",
    text263: "Receiving account",
    text264: "Accumulated Rebate",
    text265: "Withdrawal Amount",
    text266: "User Status",
    text267: "Phone number",
    text268: "Note: Open live account first and then bind user ID",
    text269: "Low Spread Rule",
    text270: "Normal Spread Rule",
    text271: "High Spread Rule",
    text272: "Bind User ID",
    text273: "Edit IB",
    text274: "MT4 Balance",
    text275: "MT4 Equity",
    text276: "MT4 Margin Ratio",
    text277: "App Transaction History",
    text278: "MT4 Transaction History",
    text279: "Rule Group Template",
    text280: "Trader Account",
    text281: "Fund Management",
    text282: "IB List",
    text283: "User List",
    text284: "Trading Account",
    text285: "Deposit and Withdrawal List",
    text286: "Please enter complete withdrawal information",
    text287: "Period",
    text288: "Withdrawal amount cannot be less than 0.01 USD.",
    text289: "Role",
    text290: "Please enter the correct User ID.",
    text291: "The rebate points cannot exceed the available points.",
    text292: "Holding Fee",
    text293: "Awaiting review",
    text294: "Transfer completed",
    text295: "Transfer failed",
    text296: "Transfer exception",
    text297: "In transfer",
    text298: "Sub-IB rule group",
    text299: "Edit rule group",
    text300: "Add rule group",
    text301: "Attribution IB",
    text302: "Net Worth Overview",
    text303: "The fee rebate cannot exceed the disposable amount.",
    text304: "Rebate",
    text305: "Fee Owned",
    text306: "Fee Remained",
    text307: "Fee Rebate",
    text308: "Fee Rebate Ratio",
    text309: "Total Rebate",
    text310: "Total Fee Rebate",
    text311: "View current rule group",
    text312: "Select at least 1 rule group",
  },
  followOrder: {
    text1: "Copy Trading System",
    text2: "Account Setup",
    text3: "Personal Info",
    text4: "Nickname",
    text5: "Full Name",
    text6: "Phone Number",
    text7: "Web Account",
    text8: "Identity",
    text9: "Statistics data",
    text10: "Transaction orders",
    text11: "Lot size",
    text12: "Monthly Avg.orders",
    text13: "Buy vs Sell",
    text14: "Win rate",
    text15: "7-days profit",
    text16: "30-days profit",
    text17: "Total profit",
    text18: "Max drawdown",
    text19: "Avg.order duration",
    text20: "2d0h26min",
    text21: "Current followers",
    text22: "Total followers",
    text23: "Avg.follow duration",
    text24: "Followers total revenue",
    text25: "Follow Fee(30 Days)",
    text26: "Follow income",
    text27: "Follow income balance",
    text28: "Follow management",
    text29: "Position list",
    text30: "Please input name",
    text31: "Please input phone number",
    text32: "Please input Web account",
    text33: "Search",
    text34: "Reset",
    text35: "Products",
    text36: "All",
    text37: "Direction",
    text38: "Buy",
    text39: "Sell",
    text40: "Open Order Type",
    text41: "Follow to Open",
    text42: "Trading Status",
    text43: "Open Date",
    text44: "Start Date",
    text45: "End Date",
    text46: "White Label",
    text47: "Follow trader",
    text48: "Open Order No.",
    text49: "Open Time",
    text50: "Opening Price",
    text51: "Take Profit",
    text52: "Stop Loss",
    text53: "Floating P/L",
    text54: "Swap",
    text55: "Leverage Ratio",
    text56: "Margin",
    text57: "Transaction record",
    text58: "Close Order Type",
    text59: "Delivery Time",
    text60: "Forced Liquidation",
    text61: "Follow to Close",
    text62: "Manual",
    text63: "Open position",
    text64: "Closed",
    text65: "Closing Date",
    text66: "Close Order No.",
    text67: "Closing Time",
    text68: "Closing Price",
    text69: "P/L",
    text70: "Subscription record",
    text71: "Status",
    text72: "Pause follow",
    text73: "Following",
    text74: "Exit following",
    text75: "Exit follow",
    text76: "First subscription",
    text77: "Exit time",
    text78: "Follow fee",
    text79: "Follow days",
    text80: "Follow time",
    text81: "Release follow time",
    text82: "Follow open order No.",
    text83: "Follow open order lot",
    text84: "Win rate",
    text85: "Avg.profit",
    text86: "Avg.loss",
    text87: "Operate",
    text88: "Follow operation record",
    text89: "Operation record",
    text90: "Follow operation",
    text91: "Operation type",
    text92: "Release follow",
    text93: "Start following",
    text94: "Operation time",
    text95: "Position disposal",
    text96: "Follow new order",
    text97: "Keep position, follow to close, system operation",
    text98: "Fund operation",
    text99: "Amount",
    text100: "Follow fund balance",
    text101: "Financial management",
    text102: "Withdrawal record",
    text103: "Extraction audit",
    text104: "Transfer audit",
    text105: "Withdrawal rejection",
    text106: "Transfer rejection",
    text107: "Complete",
    text108: "Create time",
    text109: "Withdrawal",
    text110: "Amount",
    text111: "Application time",
    text112: "Withdrawal review time",
    text113: "Transfer review time",
    text114: "Withdrawable amount",
    text115: "All",
    text116:
      "After the withdrawal is approved, the funds will be transferred to the trader's account, please check it carefully.",
    text117: "The amount available is insufficient",
    text118: "Submit",
    text119: "Cancel",
    text120: "Personal Information",
    text121: "Follow fee",
    text122: "Revenue share",
    text123: "Total revenue share amount",
    text124: "Amount",
    text125: "Ratio",
    text126: "Follow Date",
    text127: "Open Order No.",
    text128: "Average profit and loss",
    text129: "Fund operation record",
    text130: "Fund Withdrawal",
    text131: "Withdrawal amount",
    text132: "Receiving account type",
    text133: "Total revenue details",
    text134: "Follow Profit Share",
  },
};

export default messages;
